import { ThreadTrackedMovement } from '@shared/generated/graphql';
import { FeedItemType, TrackedMovementFeedItem } from '../types';

export const transformTrackedMovements = (
  movements: ThreadTrackedMovement[],
  onPausedChange: () => void
): TrackedMovementFeedItem[] =>
  movements.map((movement) => ({
    type: FeedItemType.TRACKED_MOVEMENT,
    data: {
      movementId: movement.movementId,
      shipmentId: movement.shipmentId,
      referenceNumber: movement.referenceNumber,
      isPaused: movement.isPaused,
      onPausedChange,
    },
  }));
